import {Injectable} from '@angular/core';
import {map, Observable} from "rxjs";
import {IProdGridService} from 'prod-grid';
import {HttpExtraParams, HttpFilterParam} from 'prod-shared';
import {IProdFormService} from 'prod-form';
import {AbstractProdSelectService, IProdSelectProperties} from 'prod-select';
import {Organization} from "../models/organization";
import {HttpClient} from "@angular/common/http";
import {OrganizationTreeSelect} from "../dip/organization-tree-select";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class OrganizationService extends AbstractProdSelectService implements IProdGridService, IProdFormService {
  override selectDataUrl: string = 'organizations';
  override selectProperties: IProdSelectProperties = {
    id: 'id',
    name: 'name'
  };

  constructor(public override httpClient: HttpClient, private organizationTreeSelect: OrganizationTreeSelect, private translate: TranslateService) {
    super(httpClient);
  }

  get(id: number) {
    return this.httpClient.get<{ data: Organization, success: boolean }>(`/api/organization/${id}`);
  }

  getProdGridData(params?: HttpExtraParams): Observable<Object> {
    return this.httpClient.get<{ data: { result: Organization[], totalCount: number }, success: boolean }>(`/api/organizations`, {params});
  }

  prodGridAdd(values: any): Observable<Object> {
    return this.httpClient.post(`/api/organization`, values);
  }

  prodGridPatch(values: any, id: number): Observable<Object> {
    return this.httpClient.patch(`/api/organization/${id}`, values);
  }

  prodGridRemove(id: number): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  getOrganizationFilter(): HttpFilterParam[] {
    return [new HttpFilterParam({
      property: 'id',
      operator: 'in',
      value: this.organizationTreeSelect.ids
    })];
  }

  override getSelectFilters(): HttpFilterParam[] {
    return this.getOrganizationFilter();
  }

  getTreeData(isSystem: boolean): Observable<any> {
    return this.httpClient.get<any>('/api/organizations').pipe(map(res => {
      return isSystem ? this.buildTreeForSystem(res['data'].result) : this.buildTree(res['data'].result);
    }));
  }

  buildTree(list) {
    let map = {}, node, roots = [{
      name: this.translate.instant('tree_select.all_companies_and_sites'),
      id: 0,
      organizationType: {name: 'Company'}
    }], i;

    list = list.filter(org => org.organizationType.id !== 3);

    for (i = 0; i < list.length; i += 1) {
      map[list[i].id] = i;
      list[i].children = [];
    }

    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.organization) {
        list[map[node.organization.id]].children.push(node);
      } else {
        node.isRoot = true;
        roots.push(node);
      }
    }
    return roots;
  }

  buildTreeForSystem(list) {
    let map = {}, node, roots = [
      {
        name: this.translate.instant('tree_select.all'),
        id: 0,
        organizationType: {name: 'Company'}
      },
      {
        name: this.translate.instant('tree_select.no_distributor'),
        id: -1,
        organizationType: {name: 'Distributor'},
        children: []
      }
    ], i;

    for (i = 0; i < list.length; i += 1) {
      map[list[i].id] = i;
      list[i].children = [];
    }

    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.organizationType.id === 3) {
        roots.push(node);
        node.name += ' (Distributor)'
        node.isRoot = true;
      } else if (node.distributor) {
        list[map[node.distributor.id]].children.push(node);
      } else if (node.organization) {
        list[map[node.organization.id]].children.push(node);
      } else {
        roots[1].children.push(node);
      }
    }

    return roots;
  }
}
